import React from "react";
import Leftmenu from "../components/Leftmenu";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import routes from "../routes/route";
import { Box, useTheme, useMediaQuery } from "@mui/material";

const Main = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Router>
      <Box
        sx={{
          display: 'flex',
          minHeight: '100vh',
          bgcolor: 'background.default',
          width: '100%',
        }}
      >
        {/* Sol Menü */}
        <Leftmenu />

        {/* Ana İçerik */}
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            minHeight: '100vh',
            width: { xs: '100%', md: 'calc(100% - 280px)' },
            ml: { xs: 0, md: '280px' },
            pt: { xs: '80px', md: 3 },
            px: { xs: 2, sm: 3 },
            pb: 3,
            position: 'relative',
          }}
        >
          <Routes>
            {routes.map((route, index) => (
              <Route key={index} path={route.path} element={route.element} />
            ))}
          </Routes>
        </Box>
      </Box>
    </Router>
  );
};

export default Main;
